import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { Router } from '@angular/router';
import { SilentRequest } from '@azure/msal-browser';
import { from, EMPTY } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export const silentMsalInterceptor: HttpInterceptorFn = (req, next) => {
  const msalService = inject(MsalService);
  const router = inject(Router);

  const account = msalService.instance.getActiveAccount();

  if (!account) {
    router.navigate(['/login']);
    return EMPTY;
  }

  const silentRequest: SilentRequest = {
    scopes: environment.scopes,
    account,
  };

  return from(msalService.instance.acquireTokenSilent(silentRequest)).pipe(
    switchMap(result => {
      const authReq = req.clone({
        setHeaders: { Authorization: `Bearer ${result.accessToken}` },
      });
      return next(authReq);
    }),
    catchError(() => {
      router.navigate(['/login']);
      return EMPTY;
    }),
  );
};
